/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DataPointDetailsDto,
  DataPointRequestDto,
  DataPointRequestWithRangeDto,
  DataSetFilterTemplateDto,
  DataSetRequestDto,
  DataSetResponseDto,
  SeedDataSetsRequestDto,
  SeedDataSetsWithJobsRequestDto,
} from '../models/index';
import {
    DataPointDetailsDtoFromJSON,
    DataPointDetailsDtoToJSON,
    DataPointRequestDtoFromJSON,
    DataPointRequestDtoToJSON,
    DataPointRequestWithRangeDtoFromJSON,
    DataPointRequestWithRangeDtoToJSON,
    DataSetFilterTemplateDtoFromJSON,
    DataSetFilterTemplateDtoToJSON,
    DataSetRequestDtoFromJSON,
    DataSetRequestDtoToJSON,
    DataSetResponseDtoFromJSON,
    DataSetResponseDtoToJSON,
    SeedDataSetsRequestDtoFromJSON,
    SeedDataSetsRequestDtoToJSON,
    SeedDataSetsWithJobsRequestDtoFromJSON,
    SeedDataSetsWithJobsRequestDtoToJSON,
} from '../models/index';

export interface GetDataPointDetailsRequest {
    dataPointId: string;
}

export interface GetDataPointsRequest {
    dataPointRequestDto?: DataPointRequestDto;
}

export interface GetDataPointsCsvRequest {
    dataPointRequestDto?: DataPointRequestDto;
}

export interface GetDataPointsWithRangeRequest {
    dataPointRequestWithRangeDto?: DataPointRequestWithRangeDto;
}

export interface GetDataSetsRequest {
    dataSetRequestDto?: DataSetRequestDto;
}

export interface SeedDataSetsRequest {
    seedDataSetsRequestDto?: SeedDataSetsRequestDto;
}

export interface SeedDataSetsWithJobsRequest {
    seedDataSetsWithJobsRequestDto?: SeedDataSetsWithJobsRequestDto;
}

/**
 * 
 */
export class DataSetsApi extends runtime.BaseAPI {

    /**
     */
    async getDataPointDetailsRaw(requestParameters: GetDataPointDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataPointDetailsDto>> {
        if (requestParameters.dataPointId === null || requestParameters.dataPointId === undefined) {
            throw new runtime.RequiredError('dataPointId','Required parameter requestParameters.dataPointId was null or undefined when calling getDataPointDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/data-sets/data-points/{dataPointId}`.replace(`{${"dataPointId"}}`, encodeURIComponent(String(requestParameters.dataPointId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => DataPointDetailsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDataPointDetails(requestParameters: GetDataPointDetailsRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDataPointDetailsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<DataPointDetailsDto>(response, errorHandlers);
    }

    /**
     * Returns data points of a data set.
     */
    async getDataPointsRaw(requestParameters: GetDataPointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataSetResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/data-sets/data-points`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataPointRequestDtoToJSON(requestParameters.dataPointRequestDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => DataSetResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns data points of a data set.
     */
    async getDataPoints(requestParameters: GetDataPointsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDataPointsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<DataSetResponseDto>(response, errorHandlers);
    }

    /**
     */
    async getDataPointsCsvRaw(requestParameters: GetDataPointsCsvRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/data-sets/data-points-csv`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataPointRequestDtoToJSON(requestParameters.dataPointRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getDataPointsCsv(requestParameters: GetDataPointsCsvRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDataPointsCsvRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getDataPointsWithRangeRaw(requestParameters: GetDataPointsWithRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataSetResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/data-sets/data-points-with-range`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataPointRequestWithRangeDtoToJSON(requestParameters.dataPointRequestWithRangeDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => DataSetResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDataPointsWithRange(requestParameters: GetDataPointsWithRangeRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDataPointsWithRangeRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<DataSetResponseDto>(response, errorHandlers);
    }

    /**
     */
    async getDataSetFilterTemplateRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataSetFilterTemplateDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/data-sets/filter-template`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => DataSetFilterTemplateDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDataSetFilterTemplate(errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDataSetFilterTemplateRaw(initOverrides);
        return this.configuration.handleFunction<DataSetFilterTemplateDto>(response, errorHandlers);
    }

    /**
     */
    async getDataSetsRaw(requestParameters: GetDataSetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataSetResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/data-sets/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DataSetRequestDtoToJSON(requestParameters.dataSetRequestDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => DataSetResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDataSets(requestParameters: GetDataSetsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getDataSetsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<DataSetResponseDto>(response, errorHandlers);
    }

    /**
     */
    async seedDataSetsRaw(requestParameters: SeedDataSetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/data-sets/seed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SeedDataSetsRequestDtoToJSON(requestParameters.seedDataSetsRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seedDataSets(requestParameters: SeedDataSetsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.seedDataSetsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async seedDataSetsWithJobsRaw(requestParameters: SeedDataSetsWithJobsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/data-sets/seed-job-configs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SeedDataSetsWithJobsRequestDtoToJSON(requestParameters.seedDataSetsWithJobsRequestDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async seedDataSetsWithJobs(requestParameters: SeedDataSetsWithJobsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.seedDataSetsWithJobsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
